
import { defineComponent } from 'vue';
import { formatUrls } from '@/common/utils';
import { radarLog } from '@/common/radar';


import 'swiper/swiper-bundle.css';

export default defineComponent({
  components: {

  },
  props: {
    item: {
      type: Object,
      default: () => { },
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  setup(props, ctx) {

    const onClickVideo = (e: Event) => {
      ctx.emit('video-click', e);
    };

    const onWaiting = () => {
      ctx.emit('video-waiting');
    };

    const onPlaying = () => {
      ctx.emit('video-playing', props.index);
    };

    const onError = () => {
      radarLog({
        name: 'PWA_VIDEO_ERROR',
        event_type: 'click',
        category: 'KWAI_SHARE',
        message: `error url: ${props.item?.main_mv_urls[0]?.url}`,
        src: window.location.pathname,
      });
    };

    const onEnded = () => {
    }

    const onPause = () => {
    }

    return {
      onClickVideo,
      onWaiting,
      onPlaying,
      formatUrls,
      onError,
      onEnded,
      onPause
    };
  },
});
